import { motion } from "framer-motion";
import {
  Banknote,
  HardHat,
  Scale,
  TrendingUp,
  Truck,
  Users,
} from "lucide-react";
import Reveal, { ChapterTag } from "./Reveal";

const ITEMS = [
  {
    icon: TrendingUp,
    title: "Best Price Guaranteed",
    desc: "Live market rates updated daily, always quoted upfront — no haggling, no surprises.",
    span: "lg:col-span-2 lg:row-span-2",
    theme: "dark",
  },
  {
    icon: Scale,
    title: "Transparent Weighing",
    desc: "Calibrated digital scales — weigh in front of you, every time.",
    span: "",
    theme: "light",
  },
  {
    icon: Truck,
    title: "Free Pickup",
    desc: "Free doorstep pickup across Bangalore, big or small loads.",
    span: "",
    theme: "light",
  },
  {
    icon: Banknote,
    title: "Same-Day Payment",
    desc: "Cash, UPI or bank transfer — paid before we leave site.",
    span: "",
    theme: "light",
  },
  {
    icon: Users,
    title: "Experienced Team",
    desc: "10+ years handling residential, office and industrial clearances.",
    span: "",
    theme: "light",
  },
  {
    icon: HardHat,
    title: "Bulk Scrap Handling",
    desc: "Full trucks, dismantling crews and demolition support.",
    span: "",
    theme: "green",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="scroll-mt-24 bg-brand py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="02" label="Why Choose Us" dark />
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            Built on trust. Paid on the spot.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.07 }}
                data-testid={`why-card-${i}`}
                className="group rounded-2xl border border-white/15 bg-white/10 p-8 backdrop-blur-sm transition-colors duration-300 sm:hover:bg-white/15"
              >
                <Icon className="h-9 w-9 text-white/85 transition-transform duration-300 sm:group-hover:-rotate-6 sm:group-hover:scale-110" />
                <h3 className="mt-8 font-display text-lg font-bold tracking-tight text-white lg:mt-14">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/70">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
